export default __webpack_public_path__ + "static/media/css-logo.5721a392.png";